import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';

/**
 * Tooltip Item Renderer
 * An optional renderer for node's container. In order to use, pass this method inside `itemRenderer` prop.
 */
class TooltipItemRendererInner extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { node, children } = this.props;
    if (node.tooltipProps) {
      const { place, text, theme } = node.tooltipProps;
      return (
        <div>
          <Tooltip content={text} container={document.body} place={place} theme={theme}>
            {children}
          </Tooltip>
        </div>
      );
    } else {
      return children;
    }
  }
}

TooltipItemRendererInner.propTypes = {
  node: PropTypes.object,
  children: PropTypes.array,
  tooltipId: PropTypes.string,
  updateTooltip: PropTypes.func
};

const TooltipItemRenderer = props => <TooltipItemRendererInner {...props} />;
export default TooltipItemRenderer;
